var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "commonDownloadGuide" } },
    [
      _c(
        "van-popup",
        {
          attrs: { round: "" },
          model: {
            value: _vm.showDownloadGuide,
            callback: function ($$v) {
              _vm.showDownloadGuide = $$v
            },
            expression: "showDownloadGuide",
          },
        },
        [
          _c("div", { staticClass: "close" }, [
            _c("img", {
              attrs: { src: require("@/assets/scrrenClose.png"), alt: "" },
              on: {
                click: function ($event) {
                  _vm.showDownloadGuide = false
                },
              },
            }),
          ]),
          _c("img", {
            attrs: { src: require("@/assets/downloadIcon.png"), alt: "" },
          }),
          _c("p", [_vm._v("Download the APP to get full services.")]),
          _c(
            "common-btn",
            { staticClass: "btn", attrs: { click: _vm.downLoad } },
            [_vm._v("Get APP Now")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }